import LeadFormWrapper from '@v4/common/components/organisms/LeadFormWrapper/LeadFormWrapper';

export const EnumFormIds = Object.freeze({
    SUBMODEL: 'submodel',
    VERSION: 'version',
    SOCIAL_LP: 'social-lp',
    WIDGET: 'widget',
    ADVISOR: 'advisor',
    EDITORIAL: 'editorial',
    MULTIMODEL: 'multimodel',
    SINGLE_OFFER: 'single-offer',
    OFFER_LANDING: 'offer-landing',
    OFFER_LANDING_NEW: 'offer-landing-page',
    COMPARE: 'compare',
    DKPROMO: 'dkpromo',
    CONFIGURATOR: 'configurator',
    STOCK: 'stock',
    VDP: 'vdp',
    STOCK_VDP: 'stockVdp',
    SHORTCODE_CARD: 'shortcode-card',
    FB_LP: 'fb-lp',
    VIDEO_VDP: 'vdp-video',
});

export const ConsentValues = [
    'drivek_consent_given_purpose_1',
    'drivek_consent_given_purpose_2',
    'drivek_consent_given_purpose_3',
    'drivek_consent_given_purpose_4',
    'drivek_consent_given_purpose_5',
];

export const GuIdK = 'GUIDK';

export default LeadFormWrapper;
